module.exports = __webpack_public_path__ + "static/media/shape_sunset.9f5f9a8c.svg";